const isArchivedVariant = (variant) => variant?.status === "archived";

export function getStructurePricingSnapshot(form) {
  return {
    price: String(form?.price ?? "").trim(),
    compareAtPrice: String(form?.compareAtPrice ?? "").trim(),
    cost: String(form?.cost ?? "").trim(),
  };
}

export function hasStructurePricingChanged(form, baseline) {
  const current = getStructurePricingSnapshot(form);
  const previous = getStructurePricingSnapshot(baseline);

  return (
    current.price !== previous.price ||
    current.compareAtPrice !== previous.compareAtPrice ||
    current.cost !== previous.cost
  );
}

export function applySharedPricingToVariantDrafts(drafts, form, baseline) {
  const current = getStructurePricingSnapshot(form);
  const previous = getStructurePricingSnapshot(baseline);

  return (drafts || [])
    .filter((variant) => !isArchivedVariant(variant))
    .map((variant) => ({
      ...variant,
      price: current.price !== previous.price ? current.price : variant.price,
      compareAtPrice:
        current.compareAtPrice !== previous.compareAtPrice
          ? current.compareAtPrice
          : variant.compareAtPrice,
      cost: current.cost !== previous.cost ? current.cost : variant.cost,
    }));
}
